import React, { useEffect, useState, useMemo } from 'react';
import {
  defaultFormTemplate,
  directSchemaTemplate,
  columnLabels,
  fieldOverrides,
  validationRules,
  skipFields,
  infoIcons,
  layout
} from '../API/UsersSchema';
import { API_BASE_URL } from 'config';
import { useUsersCreateStore } from '../store/useUsersCreateStore';
import { fetchCustomFieldsByMenuId } from '@utils/customFields';
import PreBuildFormNew from '@components/form-elements/PreBuidFormNew';
import { fetchJson, useGetMetaData, useMatchedMenu } from '@utils/fetchJson';
import { toast } from 'react-toastify';
import FormSkeleton from '@components/form-elements/FormSkeleton';
import { ControlledPhoneInput } from '@components/index';
const CreateUsers = ({ onClose, onSave }) => {
  // This is used to get menuid from the module name /link
  const menuId = useMatchedMenu('users');
  // use this function to get the module metadata
  const  menuData = useGetMetaData('users');
  // This is use to open create module globally. Payload use to trasfer the data
  const { isOpen, payload: payloadWrapper, close } = useUsersCreateStore();
  //const payload = payloadWrapper?.payload || payloadWrapper || {};
  const payload = useMemo(
  () => payloadWrapper?.payload || payloadWrapper || {},
  [payloadWrapper]
  );
  
  // use this to set default fields for the module
  const [defaultFormData, setDefaultFormData] = useState(defaultFormTemplate);
  const memoFormData = useMemo(() => defaultFormData, [defaultFormData]);
  // memorise the default data to rerender againa and again
  
  //Note: Merage all custom feilds with default
  const [mergedFieldOverrides, setMergedFieldOverrides] = useState(fieldOverrides);
  const [mergedValidationRules, setMergedValidationRules] = useState(validationRules);
  const [mergedColumnLabels, setMergedColumnLabels] = useState(columnLabels);
  const [mergedSchemaTemplate, setMergedSchemaTemplate] = useState(directSchemaTemplate);
  const [mergedLayout, setMergedLayout] = useState(layout);
  const [customFields, setCustomFields] = useState([]);
  const [initialData, setInitialData] = useState(false);
  
  // use this to overrite any feild

   const customeModules ={
      contactNo: () => <ControlledPhoneInput
                          label="Mobile Number"
                          country="in"
                          value={defaultFormData?.contactNo}
                          onChange={(fullDigits) => setDefaultFormData(prev => ({...prev,contactNo:fullDigits}))}   // ← important
                          />,
      whatsappNo: () => <ControlledPhoneInput
      label="WhatsApp number"
      country="in"
      value={defaultFormData?.whatsappNo}
      onChange={(fullDigits) => setDefaultFormData(prev => ({...prev,whatsappNo:fullDigits}))}
      />
    }


  // const customeModules ={
   
  //    contactNo: () => <ControlledPhoneInput
  //                       label="Mobile Number"
  //                       country="in"
  //                       value={defaultFormData?.contactNo}
  //                        onChange={(fullDigits) => setDefaultFormData(prev => ({...prev,contactNo:fullDigits}))}   // ← important
  //                       />,
  //     whatsappNo: () => <ControlledPhoneInput
  //                       label="WhatsApp number"
  //                       country="in"
  //                       value={defaultFormData?.whatsappNo}
  //                        onChange={(fullDigits) => setDefaultFormData(prev => ({...prev,whatsappNo:fullDigits}))}   // ← important
  //                       />
  //   }
  // use this to set default data and edit record data.
  useEffect(() => {
    const setupFormData = async () => {
      // 1. Editing existing record
      if (payload?.record_id) {
        setInitialData(false);
        try {
            const res = await fetchJson(`${API_BASE_URL}/user/${payload.record_id}?menuId=${menuId}`, {
            method: 'GET',
          });
          const recordData = res?.data?.[0] || {};
          setDefaultFormData(prev => ({...prev,...payload,...recordData,menuId,password:"",}));
        } catch (err) {
          console.log(err);
          setDefaultFormData(prev => ({...prev,...payload, menuId,password:"",}));
        }
        setInitialData(true);
      }
      else {
        // 2. Creating new record
        setDefaultFormData(prev => ({...prev,...payload, menuId }));
        setInitialData(true);
        
      }
    };
    setupFormData();
    console.log("laoding user data");
    console.log("laoding user data",payload);
    console.log("laoding user data",menuId);
  }, [payload, menuId]);

// this useEffect use to get all the dynamic and statis fields from the server and update default values 
useEffect(() => {
  if (!isOpen || !menuId) return;

  const loadFields = async () => {
    try {
      const {
        injectedLayout,
        customFields,
        extendedDefaults,
        extendedValidations,
        extendedLabels,
        extendedOverrides,
        extendedSchema,
        generatedLayout
      } = await fetchCustomFieldsByMenuId(menuId, menuData, {
        defaultFormTemplate,
        validationRules,
        fieldOverrides,
        columnLabels,
        directSchemaTemplate,
        layout,
        autoInjectLayout: true,
      });

      let finalRules = {...extendedValidations };

        // If creating a new user (no record_id), require password
        if (!payload?.record_id) {
          finalRules.password = { required: true,pattern: { value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{6,}$/, message: 'Invalid password. Must contain 1 uppercase, 1 lowercase, 1 digit, 1 symbol, and be at least 6 characters long.'}};
        }

      setCustomFields(customFields);
      setMergedValidationRules(finalRules);
      setMergedColumnLabels(extendedLabels);
      setDefaultFormData(prev => ({
        ...extendedDefaults,
        ...prev,
      }));
      setMergedFieldOverrides(extendedOverrides);
      setMergedSchemaTemplate(extendedSchema);
      setMergedLayout(injectedLayout);
    } catch (err) {
      toast.error('Failed to load custom fields');
    }
  };
  loadFields();
}, [isOpen, menuId, menuData, payload?.parent_id, payload?.is_parent]);
const updateData = (updater) => {
  setDefaultFormData(prev => {
    // If updater is a function, call it (React state API)
    const next = typeof updater === 'function' ? updater(prev) : updater;
    return next;
  });
};
  if (!isOpen) return null;
  const loading = payload?.record_id && !initialData;
  
  // PreBuildFormNew use to create form for the module.
  /*
  * directSchema : used to show form feilds
  * getDefApi this is used to get the datatabel feilds details like name,type default value etc.
  * saveApi : this is used to save the data
  * updateApi : use to update the record.
  * formDataPre: this is the form data
  * primaryKey: this identified the which is the primary key for module.
  * sidebarSize : this is used to define the module sixe. lg is large. md is medium
  * title : this is used to show the from title
  * onClose : do action on close.
  * skipFields : this is used to skip the feilds.
  * fieldOverrides : if you want to add new module or override any filed behaviour use this.
  * validationRules : add form validation
  * labels: if you want to override the lable use this.
  * editId : this is used to identified the edit key
  * recordId: this is used to identified the primary key.
  */
  return (
    <> {loading ? (
      <div className='modal-panel size-lg fixed top-[50px] right-0 h-[calc(100vh-56px)] bg-white shadow-lg z-50 flex flex-col w-screen max-w-full md:w-full md:w-[700px]'>
      <FormSkeleton /> </div>
    ) : (
    <PreBuildFormNew
      menuId={menuId}
      onReset={()=>{setDefaultFormData({...defaultFormTemplate, menuId })}}
      directSchema={mergedSchemaTemplate}
      getDefApi={`${API_BASE_URL}/getDefinations`}
      saveApi={`${API_BASE_URL}/user/add`}
      updateApi={`${API_BASE_URL}/user/edit/${memoFormData?.adminID}`}
      //formDataPre={memoFormData}
      formData={defaultFormData}
      setFormData={updateData}
      primaryKey="adminID"
      sidebarSize="lg"
      //title="Create Users"
      title={payload?.record_id ? "Update User": "Create User"}
      onClose={(res) =>{ setDefaultFormData(defaultFormTemplate);close(res)}}
      skipFields={skipFields}
      fieldOverrides={mergedFieldOverrides}
      validationRules={mergedValidationRules}
      labels={mergedColumnLabels}
      infoIcons={infoIcons}
      layout={mergedLayout}
      editId={memoFormData?.adminID}
      recordId={memoFormData?.adminID}
      customModules={(customeModules ? customeModules : {})}
      canEdit={ memoFormData?.status !== "delete"}
    />
    )}
  </>
  
  );
};
export default CreateUsers;